/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicationStatementResponseDto
 */
export interface MedicationStatementResponseDto {
    /**
     * Medication statement ID
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    patientId: string;
    /**
     * Medication name
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    name: string;
    /**
     * Medication dose (e.g., '10mg', '2 tablets')
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    dose?: string;
    /**
     * Frequency (e.g., 'twice daily', 'every 8 hours')
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    frequency?: string;
    /**
     * Purpose or reason for medication
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    purpose?: string;
    /**
     * Date asserted
     * @type {string}
     * @memberof MedicationStatementResponseDto
     */
    dateAsserted: string;
}

/**
 * Check if a given object implements the MedicationStatementResponseDto interface.
 */
export function instanceOfMedicationStatementResponseDto(value: object): value is MedicationStatementResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dateAsserted' in value) || value['dateAsserted'] === undefined) return false;
    return true;
}

export function MedicationStatementResponseDtoFromJSON(json: any): MedicationStatementResponseDto {
    return MedicationStatementResponseDtoFromJSONTyped(json, false);
}

export function MedicationStatementResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicationStatementResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'name': json['name'],
        'dose': json['dose'] == null ? undefined : json['dose'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
        'dateAsserted': json['dateAsserted'],
    };
}

export function MedicationStatementResponseDtoToJSON(json: any): MedicationStatementResponseDto {
    return MedicationStatementResponseDtoToJSONTyped(json, false);
}

export function MedicationStatementResponseDtoToJSONTyped(value?: MedicationStatementResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'name': value['name'],
        'dose': value['dose'],
        'frequency': value['frequency'],
        'purpose': value['purpose'],
        'dateAsserted': value['dateAsserted'],
    };
}

